import { Fragment } from 'react';
import { exceptionItemFactory } from '../../../common';
import { CardDetailListItemElement } from '../../styles';

const SidebarExceptionItem = exceptionItemFactory({
    ExceptionItemWrapper: CardDetailListItemElement,
});

const SidebarExceptionsInfo = ({
    exceptions: { advance, length, price, reservationCount, secondaryRange },
    timeUnit,
    isServiceDayUse,
}: $TSFixMe) => (
    <Fragment>
        {advance ? <SidebarExceptionItem type="advance" range={advance} timeUnit={timeUnit} /> : null}
        {length ? (
            <SidebarExceptionItem
                type="length"
                range={length}
                timeUnit={timeUnit}
                isServiceDayUse={isServiceDayUse}
                secondaryRange={secondaryRange}
            />
        ) : null}
        {price ? <SidebarExceptionItem type="price" range={price} timeUnit={timeUnit} /> : null}
        {reservationCount ? (
            <SidebarExceptionItem type="reservationCount" timeUnit={timeUnit} range={reservationCount} />
        ) : null}
    </Fragment>
);

export default SidebarExceptionsInfo;
